/** Reason the session ended (expiry or explicit logout). */
export const SESSION_ENDED_REASON = {
  INACTIVITY: 'inactivity',
  MAX_DURATION: 'maxDuration',
  USER_LOGOUT: 'userLogout',
} as const;

export type SessionEndedReason = (typeof SESSION_ENDED_REASON)[keyof typeof SESSION_ENDED_REASON];
